import { render, staticRenderFns } from "./LanguageCheck.vue?vue&type=template&id=7558b2e8"
import script from "./LanguageCheck.vue?vue&type=script&lang=ts"
export * from "./LanguageCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports